import { Box } from "@chakra-ui/layout";
import Stepper from "components/Stepper";
import {
  Control,
  UseFormReset,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from "react-hook-form";
import { useEffect } from "react";
import {
  EmpresaResponse,
  TipoCadastroEmpresa,
} from "core/resources/types/empresa";
import getSteps from "./getSteps";

function EmpresaWizardForms({
  data,
  control,
  setValue,
  watch,
  trigger,
  reset,
  currentStep,
  setCurrentStep,
  customHeader,
  tipoCadastroEmpresa,
  isUnidadePessoaEdit,
  requiredEndereco = true,
  hideForm,
}: {
  data?: EmpresaResponse;
  control: Control<EmpresaResponse>;
  setValue: UseFormSetValue<EmpresaResponse>;
  watch: UseFormWatch<EmpresaResponse>;
  trigger: UseFormTrigger<EmpresaResponse>;
  reset: UseFormReset<EmpresaResponse>;
  currentStep: number;
  setCurrentStep: (step: number) => void;
  customHeader?: any;
  tipoCadastroEmpresa?: TipoCadastroEmpresa;
  isUnidadePessoaEdit?: boolean;
  requiredEndereco?: boolean;
  hideForm?: boolean;
}) {
  const form = watch();
  const _steps = getSteps({
    tipoCadastroEmpresa,
    isUnidadePessoaEdit,
    requiredEndereco,
    form,
  });

  useEffect(() => {
    if (data?.id) {
      reset(data);
      trigger();
    }
  }, [data, reset, trigger]);

  return (
    <Box>
      <Box mt={4}>
        <Stepper
          steps={_steps}
          current={currentStep}
          onClickStep={setCurrentStep}
        />
      </Box>
      <Box pt="32px">
        {customHeader}

        {!hideForm
          ? _steps[currentStep].component({
              control,
              setField: setValue,
              watch,
              isEdit: !!data?.id,
            })
          : null}
      </Box>
    </Box>
  );
}

export default EmpresaWizardForms;
